export default {
  C202b_Index: {
    generalTab: 'Thông tin chung',
    divide: 'Chia ra',
    detailOptionTab: 'Tùy chọn hiển thị',
  },
  generalTab: {
    bankTransfer: 'Chuyển khoản',
    cashAtTreasury: 'Tiền mặt tại KB',
    cashAtBank: 'Tiền mặt tại NH',
    refNo: 'Số giấy rút',
    project: 'CTMT, DA',
    commitmentAndStructureContract: 'Số CKC, HĐK',
    commitmentAndStructureContractToolTip: 'Số cam kết chi, Hợp đồng khung',
    commitmentAndActionContract: 'Số CKC, HĐTH',
    commitmentAndActionContractToolTip: 'Số cam kết chi, Hợp đồng thực hiện',
    taxPay: 'Nộp thuế',
    taxCode: 'Mã số thuế',
    contentCode: 'Mã NDKT',
    chapterCode: 'Mã chương',
    taxPeroid: 'Kỳ thuế',
    organManage: 'CQ quản lý thu',
    showToContentCol: 'Hiển thị thông tin kèm theo lên cột nội dung',
    showReceiptOrg: 'Hiển thị đơn vị nhận tiền',
    orgName: 'Tên đơn vị',
    payee: 'Người nhận tiền',
    KBNNAccounting: 'KBNN hạch toán khoản thu',
    CompanyName: 'Đơn vị rút dự toán',
    CompanyCode: 'Mã quan hệ NS',
    openAt: 'Mở tại',
    address: 'Địa chỉ',
    accountingObjectBankAccount: 'Mã ngân hàng, KB',
    accountingObjectBankName: 'Tại KBNN (NH)',
    bankAccount: 'Tài khoản',
    identificationNumber: 'CMND',
    issueDate: 'Cấp ngày',
    issueBy: 'Nơi cấp'
  },
  detailOptionTab: {
    paymentDetails: 'Nội dung thanh toán là',
    notRepeatDuplicate: 'Không lặp MLNS ( nếu trùng )',
    emptyColumns: 'Để trống cột Mã ngành KT, Mã nguồn (trường hợp Tạm ứng)',
    showAdditionalRow: 'Hiển thị thêm dòng',
    toContentColumn: 'lên cột nội dung',
    repeatTitleSignature: 'Lặp lại tiêu đề và chữ ký ở mỗi trang',
    rowInOnePage: 'Số dòng 1 trang',
    emptyRowInLastPage: 'Số dòng trống ở trang cuối',
    pageAfterLowerAquaterPage: 'Các trang sau hạ thấp 1/4 trang',
    previewDescription: 'Xem trước',
  },
};
